var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[(_vm.isAccount == 1)?_c('Login'):_vm._e(),(_vm.isAccount == 2)?_c('Register'):_vm._e(),(_vm.isAccount == 3)?_c('Forget'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }